var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VCard',[_c('VCardText',[_c('VOpeningHourBundle',{ref:"openingHour",attrs:{"title":_vm.$t('venue.openingHours'),"info-text":_vm.$t('venue.infoOpeningHours.openingHours')}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }